document.addEventListener('DOMContentLoaded', function() {
  var BUNDLES = {
    single: { name: 'Single Bottle', price: 'Rs 1,499' },
    duo: { name: 'The 60-Day Glow', price: 'Rs 2,799' },
    trio: { name: 'The 90-Day Ritual', price: 'Rs 3,699' }
  };
  var selected = 'trio';

  function selectBundle(key) {
    selected = key;
    document.querySelectorAll('.bundle-card').forEach(function(c) {
      c.classList.toggle('selected', c.getAttribute('data-bundle') === key);
    });
    var p = BUNDLES[key].price;
    ['atcPrice', 'atcPrice2'].forEach(function(id) {
      var e = document.getElementById(id);
      if (e) e.textContent = p;
    });
    var sp = document.getElementById('stickyPrice');
    if (sp) sp.textContent = p;
  }

  document.querySelectorAll('.bundle-card').forEach(function(card) {
    card.addEventListener('click', function() {
      selectBundle(card.getAttribute('data-bundle'));
    });
  });

  document.querySelectorAll('.thumbs button').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var mainImg = document.getElementById('mainImg');
      if (mainImg) mainImg.src = btn.getAttribute('data-src');
      document.querySelectorAll('.thumbs button').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
    });
  });

  document.querySelectorAll('.qa button').forEach(function(b) {
    b.addEventListener('click', function() {
      var qa = b.parentElement;
      var ans = b.nextElementSibling;
      var open = qa.classList.contains('open');
      document.querySelectorAll('.qa').forEach(function(x) {
        x.classList.remove('open');
        var a = x.querySelector('.ans');
        if (a) a.style.maxHeight = null;
      });
      if (!open) {
        qa.classList.add('open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });

  var toastTimer;
  function addToCart() {
    var b = BUNDLES[selected];
    var msg = document.getElementById('toastMsg');
    var t = document.getElementById('toast');
    if (!msg || !t) return;
    msg.textContent = 'Added to bag · ' + b.name + ' · ' + b.price;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      t.classList.remove('show');
    }, 2600);
  }
  window.addToCart = addToCart;

  var buy = document.getElementById('buy');
  var sticky = document.getElementById('sticky');
  if (buy && sticky) {
    window.addEventListener('scroll', function() {
      var past = buy.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('show', past);
    });
  }

  var lb = document.getElementById('lightbox');
  var lbImg = document.getElementById('lbImg');
  if (lb && lbImg) {
    document.querySelectorAll('.vid').forEach(function(v) {
      v.addEventListener('click', function() {
        var img = v.querySelector('img');
        if (img) lbImg.src = img.src;
        lb.classList.add('show');
      });
    });
    window.closeLightbox = function() {
      lb.classList.remove('show');
    };
    lb.addEventListener('click', function(e) {
      if (e.target === lb) window.closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') window.closeLightbox();
    });
  }
});
